var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeviceDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.5H19.5V4.5H22.5V1.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6H19.5V9H22.5V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5H15V4.5H18V1.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H15V9H18V6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15H10.5V16.5H12V19.5H10.5V21H17.25V19.5H13.5V16.5H21C21.3978 16.5 21.7794 16.3419 22.0606 16.0606C22.3419 15.7794 22.5 15.3978 22.5 15V10.5H21V15Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5H13.5V3H4.5C4.1022 3 3.7206 3.15803 3.43935 3.43935C3.15803 3.7206 3 4.1022 3 4.5V9H4.5V4.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H3C2.6022 10.5 2.2206 10.658 1.93935 10.9394C1.65802 11.2206 1.5 11.6022 1.5 12V21C1.5 21.3978 1.65802 21.7794 1.93935 22.0606C2.2206 22.3419 2.6022 22.5 3 22.5H7.5C7.8978 22.5 8.2794 22.3419 8.56065 22.0606C8.84197 21.7794 9 21.3978 9 21V12C9 11.6022 8.84197 11.2206 8.56065 10.9394C8.2794 10.658 7.8978 10.5 7.5 10.5ZM7.5 21H3V12H7.5V21Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceDetails);
export default __webpack_public_path__ + "static/media/ic-device-details.9b843fb08018aa7d359e575d24d033e1.svg";
export { ForwardRef as ReactComponent };